import React from 'react'

interface VsbProps extends React.HTMLAttributes<HTMLDivElement> {
  xs?: boolean
  sm?: boolean
  md?: boolean
  lg?: boolean
  xl?: boolean
}

/**
 * Viewable breakpoints — shows children only at the breakpoints whose prop is true.
 * Breakpoints (matches tailwind.config): sm=428, md=900, lg=1024, xl=1280.
 */
export const Vsb = ({ xs, sm, md, lg, xl, className, ...rest }: VsbProps) => {
  const visibility = [
    xs && 'max-sm:block',
    sm && 'sm:max-md:block',
    md && 'md:max-lg:block',
    lg && 'lg:max-xl:block',
    xl && 'xl:block'
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <div
      className={`hidden ${visibility} ${className ?? ''}`.trim()}
      {...rest}
    />
  )
}
